import {keyframes} from 'styled-components'

export const rowAnimantion = keyframes `
    0% { opacity: 0; }
    30% { opacity: 0.5; }
    100% { opacity: 1 ;}
`